import { withSubComponent } from '@magnetic/higher-order-components';
import { IconContext } from '@magnetic/icons';
import { consoleWarn } from '@magnetic/lib';
import React, { forwardRef } from 'react';
import { ButtonLoaderIcon } from './button-loader-icon.js';
import { Group } from './group/index.js';
import { useButtonClassNames } from './use-button-class-names.js';
import { useButtonClick } from './use-button-click.js';
import '@magnetic/theme';
import './style.css.js';

const ButtonComponent = forwardRef(
  ({
    admin = false,
    analytics,
    as,
    block = false,
    children,
    className,
    destructive = false,
    disabled,
    icon,
    kind = "primary",
    loading = false,
    margin,
    onClick,
    rightIcon,
    size = "md",
    ...rest
  }, ref) => {
    const Component = as != null ? as : "button";
    consoleWarn({
      prop: kind,
      propValues: ["default"],
      message: 'The `kind="default"` prop has been deprecated and will render as a `primary`.'
    });
    const classNames = useButtonClassNames({
      admin,
      block,
      children,
      className,
      destructive,
      icon,
      kind,
      loading,
      margin,
      rightIcon,
      size
    });
    const handleOnClick = useButtonClick({
      analytics,
      disabled,
      onClick
    });
    return /* @__PURE__ */ React.createElement(IconContext.Provider, {
      value: {
        weight: "bold",
        size: 16,
        color: "var(--mds-button-icon-color)"
      }
    }, /* @__PURE__ */ React.createElement(Component, {
      type: Component === "button" ? "button" : void 0,
      ...rest,
      "aria-disabled": loading || disabled,
      className: classNames,
      disabled: loading || disabled,
      onClick: handleOnClick,
      ref
    }, /* @__PURE__ */ React.createElement(ButtonLoaderIcon, {
      icon,
      loading
    }), children, rightIcon));
  }
);
const Button = withSubComponent(ButtonComponent, {
  Group
});

export { Button };
//# sourceMappingURL=index.js.map
